export const colors = {
  blue: 'gradient-blue',
  'blue-green': 'gradient-teal', // old color
  teal: 'gradient-teal',
  turquise: 'gradient-cyan',
  cyan: 'gradient-cyan', // old color
  green: 'gradient-green',
  yellow: 'gradient-yellow',
  orange: 'gradient-orange',
  brown: 'gradient-brown',
  indigo: 'gradient-indigo',
  'red-dark': 'gradient-red-dark',
  sduigenta: 'gradient-sduigenta',
  pink: 'gradient-pink',
  violet: 'gradient-violet',
  purple: 'gradient-purple',
  red: 'gradient-sduigenta'
}

export const contrastCorrectColors = {
  blue: {
    background: 'blue-light-bg',
    text: 'blue-dark'
  },

  'blue-green': {
    background: 'teal-light-bg',
    text: 'teal-dark'
  },

  teal: {
    background: 'teal-light-bg',
    text: 'teal-dark'
  },

  cyan: {
    background: 'cyan-light-bg',
    text: 'cyan-dark'
  },

  turquise: {
    background: 'cyan-light-bg',
    text: 'cyan-dark'
  },

  turquoise: {
    background: 'cyan-light-bg',
    text: 'cyan-dark'
  },

  green: {
    background: 'green-light-bg',
    text: 'green-dark'
  },

  yellow: {
    background: 'yellow-light-bg',
    text: 'yellow-dark'
  },

  orange: {
    background: 'orange-light-bg',
    text: 'orange-dark'
  },

  brown: {
    background: 'brown-light-bg',
    text: 'brown-dark'
  },

  indigo: {
    background: 'indigo-light-bg',
    text: 'indigo-dark'
  },

  'red-dark': {
    background: 'red-light-bg',
    text: 'red-dark'
  },

  red: {
    background: 'pink-light-bg',
    text: 'pink-dark'
  },

  pink: {
    background: 'pink-light-bg',
    text: 'pink-dark'
  },

  violet: {
    background: 'violet-light-bg',
    text: 'violet-dark'
  },

  purple: {
    background: 'purple-light-bg',
    text: 'purple-dark'
  }
}
